import React from "react";
import { GridColDef } from "../../../Unknown/DataGrid";
import Chip, { ChipProps } from "../../../Unknown/Chip";
import {
  AppointmentAIReportColumnItemStatus,
  AppointmentAIReportRowItem,
} from "../types";

type ColumnValue = {
  status: AppointmentAIReportRowItem["status"];
  statusTranslation: string;
  color: ChipProps["color"];
};

export type ColumnStatusTranslations = {
  columnStatus: string;
  statusApproved: string;
  statusRequiresReview: string;
  statusInReview: string;
};

const colors: Record<AppointmentAIReportRowItem["status"], ChipProps["color"]> =
  {
    sent: "success",
    unsent: "success",
    requires_review: undefined,
    in_review: "primary",
  };

const getColumnStatus = (params: {
  columnItem: AppointmentAIReportColumnItemStatus;
  translations: ColumnStatusTranslations;
}): GridColDef<AppointmentAIReportRowItem, ColumnValue> => {
  const { columnItem, translations } = params;

  return {
    field: columnItem.field,
    disableColumnMenu: true,
    headerName: translations.columnStatus,
    flex: 0.5,
    minWidth: 120,
    getApplyQuickFilterFn: () => null,
    valueGetter: ({ row }) => {
      const { status } = row;

      const statusTranslations: Record<string, string> = {
        requires_review: translations.statusRequiresReview,
        in_review: translations.statusInReview,
        unsent: translations.statusApproved,
        sent: translations.statusApproved,
      };

      const color = colors[status];

      const statusTranslation = statusTranslations[status] || "";

      return { status, statusTranslation, color };
    },
    renderCell: (renderParams) => {
      if (!renderParams.value) return null;

      const { statusTranslation, color } = renderParams.value;

      return (
        <Chip variant="outlined" label={statusTranslation} color={color} />
      );
    },
  };
};

export default getColumnStatus;
